import { render, staticRenderFns } from "./ConfiguracaoRouter.vue?vue&type=template&id=1efa40cc"
import script from "./ConfiguracaoRouter.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoRouter.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoRouter.vue?vue&type=style&index=0&id=1efa40cc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports